import { useCallback, useMemo } from 'react'
import {
    ISelectItemInCart,
    OrderItemViewModel,
    SelectItemInCartType,
    VoidCompReasonModelWithItemId,
} from 'store/models/sellModels'
import { VoidCompReasonType, VoidCompReasonModel } from 'models'
import Decimal from 'decimal.js'
import { mockDiscountForComp } from 'views/Sale/discount/mockDiscountForComp'
import { EntireDiscountTag, ItemDiscountTag } from './DiscountTag'
import { calculateDiscountAmount } from 'views/Sale/utils/orderCalculation/discountCalculation'
import usePosNameFormat from 'components/Sell/hook/usePosNameFormat'
import { isComp } from 'components/Sell/utils/common'

interface props {
    voidComp: VoidCompReasonModel | undefined
    orderItem: OrderItemViewModel | undefined
    margin?: number
    totalLinePrice?: number
    handleSelected?: (comp: VoidCompReasonModelWithItemId) => void
    isSelectedComp?: boolean
    setSelectedItemCart?: (item: ISelectItemInCart) => void
    selectComp?: VoidCompReasonModelWithItemId
    onRemoveComp?: (item: OrderItemViewModel) => void
    noPaddingRight?: boolean
}
export function CartComp({
    voidComp,
    orderItem: item,
    totalLinePrice = 0,
    margin = 4,
    handleSelected,
    isSelectedComp = false,
    setSelectedItemCart,
    onRemoveComp,
    selectComp,
    noPaddingRight = false,
}: props) {
    const { getCompName, getCompDescription } = usePosNameFormat()
    const isSelected = useMemo(() => {
        return selectComp
            ? (selectComp?.id && item && selectComp?.id === item.id) ||
                  (!item && !selectComp?.id)
            : isSelectedComp
    }, [isSelectedComp, item, selectComp])

    const clickToSelectComp = useCallback(() => {
        if (setSelectedItemCart)
            setSelectedItemCart({
                type: SelectItemInCartType.Comp,
                data: { ...voidComp, id: item?.id },
            })
        else if (handleSelected) handleSelected({ ...voidComp, id: item?.id })
    }, [setSelectedItemCart, item, voidComp, handleSelected])

    const compDiscount = useMemo(() => {
        if (!item && isComp(voidComp))
            return calculateDiscountAmount(
                mockDiscountForComp(
                    voidComp!,
                    true,
                    new Decimal(totalLinePrice),
                ),
                new Decimal(totalLinePrice),
            ).toNumber()
        else return item?.totalCompDiscount ?? 0
    }, [item, totalLinePrice, voidComp])

    if (!voidComp || voidComp.type === VoidCompReasonType.Void) return null

    return item ? (
        <ItemDiscountTag
            name={getCompName(voidComp)}
            discountAmount={compDiscount}
            isSelected={isSelected}
            onClick={clickToSelectComp}
            margin={margin}
            note={getCompDescription(voidComp)}
            onRemove={
                onRemoveComp && item ? () => onRemoveComp(item) : undefined
            }
            noPaddingRight={noPaddingRight}
        />
    ) : (
        <EntireDiscountTag
            name={getCompName(voidComp)}
            discountAmount={compDiscount}
            isSelected={isSelected}
            onClick={clickToSelectComp}
            margin={margin}
            note={getCompDescription(voidComp)}
        />
    )
}
